import { Component, OnInit } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ActivatedRoute } from "@angular/router";
import * as SecureLS from "secure-ls";
import * as moment from "moment";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { GlobalService } from "src/app/services/global.service";
import CryptoJS from "crypto-js";
import { NgxSpinnerService } from "ngx-spinner";
import { CommonService } from "src/app/services/common.service";
import { StorageService } from "../../services/storage.service";

@Component({
  selector: "app-liveclasslist",
  templateUrl: "./liveclasslist.component.html",
  styleUrls: ["./liveclasslist.component.css"],
})
export class LiveclasslistComponent implements OnInit {
  private ls = new SecureLS({ encodingType: "aes" });
  pageshow = true;
  showpage: boolean = false;
  page: number = 1;
  page_size: number = 10;
  liveclasslist = [];
  total: number;
  table_pagination: boolean;
  user_role = this.storageService.getRole();
  filter: any;
  filter_date: string;
  filter_from: any;
  filter_end: any;
  department_id: string;
  subject_id: string;
  professor_id: string;
  classroom_id: string;
  searchForm: any;
  professorname: Object;
  professorData: any;
  department: Object;
  dept: any;
  classroom: Object;
  class: any;
  subject: Object;
  isLoginType: boolean;
  subjectData: any;
  batchid: any;
  departmentid: any;
  professorid: any;
  stufilter: boolean = true;
  profid: boolean = false;
  chiparray: any = [];
  filtervalues: boolean;
  constructor(
    private storageService: StorageService,
    private modalService: NgbModal,
    public globalService: GlobalService,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private spinner: NgxSpinnerService,
    public commonService: CommonService
  ) { }
  roleId = this.storageService.getRole();
  async ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      this.isLoginType = !!params["loginType"];
      this.globalService.loginType = params.loginType;
      if (params.loginType == "impersonate") {
        this.roleId = this.ls.get("impersonate_role");
      } else {
        this.roleId = this.storageService.getRole();
      }
    });
    this.searchForm = this.fb.group({
      id: [""],
      subname: [""],
      proname: [""],
      email: [""],
      depname: [""],
      classname: [""],
    });
    this.getProfessor();
    this.getDepartment();
    this.getclassroom();
    this.getSubject();
    await this.getLiveStreamClass(1);
    this.user_role = this.storageService.getRole();
  }
  get forms1() {
    return this.searchForm.controls;
  }
  async getPage(page: number) {
    this.page = page;
    await this.getLiveStreamClass(page);
  }

  async refresh() {
    await this.getLiveStreamClass(this.page);
  }

  Filter(subject_id, professor_id, department_id, classroom_id) {
    this.filtervalues = true;
    this.chiparray = [];

    if (this.subject_id != undefined && this.subject_id != "") {
      var subject = this.subjectData.filter((x) => x.id == this.subject_id);
      this.chiparray.push("Subject:" + " " + subject[0].name);
    }

    if (this.professor_id != undefined && this.professor_id != "") {
      var proffessor = this.professorData.filter(
        (x) => x.id == this.professor_id
      );
      this.chiparray.push(
        "Proff:" +
        " " +
        proffessor[0].first_name +
        " " +
        proffessor[0].last_name
      );
    }

    if (this.department_id != undefined && this.department_id != "") {
      var dept = this.dept.filter((x) => x.id == this.department_id);
      this.chiparray.push("Dept:" + " " + dept[0].name);
    }

    if (this.classroom_id != undefined && this.classroom_id != "") {
      var classroom = this.class.filter((x) => x.id == this.classroom_id);
      this.chiparray.push("Class:" + " " + classroom[0].name);
    }
    this.profid = true;
    this.subject_id = subject_id;
    this.professor_id = professor_id;
    this.departmentid = department_id;
    this.classroom_id = classroom_id;
    this.pageshow = true;
    this.page = 1;
    this.getLiveStreamClass(this.page);
  }
  async getProfessor() {
    this.spinner.show();
    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      role_id: this.storageService.getRole(),
    };
    this.professorname = await this.globalService.get(
      "user/profeser/dropdown",
      filter, true
    );

    this.professorData = this.professorname["content"];
    this.spinner.hide();
  }
  async getDepartment() {
    this.spinner.show();
    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      role_id: this.storageService.getRole(),
    };
    this.department = await this.globalService.get(
      "department/list/dropdown",
      filter, true
    );

    this.dept = this.department["content"];
    this.spinner.hide();
  }
  async getclassroom() {
    this.spinner.show();
    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      role_id: this.storageService.getRole(),
    };
    this.classroom = await this.globalService.get(
      "classroom/list/dropdown",
      filter, true
    );

    this.class = this.classroom["content"];
    this.spinner.hide();
  }
  async getSubject() {
    this.spinner.show();
    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      role_id: this.storageService.getRole(),
    };
    this.subject = await this.globalService.get(
      "subject/list/dropdown",
      filter, true
    );

    this.subjectData = this.subject["content"];
    this.spinner.hide();
  }

  async getLiveStreamClass(page) {
    this.spinner.show();
    this.route.queryParams.subscribe((params) => {
      this.isLoginType = !!params["loginType"];
      this.globalService.loginType = params.loginType;
      if (params.loginType == "impersonate") {
        this.roleId = this.ls.get("impersonate_role");
        if (this.roleId == 4) {
          this.professorid = this.ls.get("impersonate_user_id");
        } else {
          this.departmentid = this.ls.get("impersonate_department_id");
          this.batchid = this.ls.get("impersonate_batch_id");
        }
      } else {
        this.roleId = this.storageService.getRole();
        if (this.roleId == 4) this.professorid = this.ls.get("createdBy");
        else {
          this.departmentid = this.ls.get("department_id");
          this.batchid = this.ls.get("batch_id");
        }
      }
    });
    let filter = {};
    if (this.roleId == 5) {
      this.stufilter = false;
      filter = {
        user_id: this.ls.get("createdBy"),
        vendor_id: this.ls.get("vendor_id"),
        role_id: this.storageService.getRole(),
        department_id: this.departmentid,
        batch_id: this.batchid,
        page: page,
        page_size: this.page_size,
      };
    } else if (this.roleId == 4) {
      filter = {
        user_id: this.ls.get("createdBy"),
        vendor_id: this.ls.get("vendor_id"),
        role_id: this.storageService.getRole(),
        professor_id: this.professorid,
        page: page,
        page_size: this.page_size,
      };
    } else {
      filter = {
        user_id: this.ls.get("createdBy"),
        vendor_id: this.ls.get("vendor_id"),
        role_id: this.storageService.getRole(),
        professor_id: this.professor_id,
        department_id: this.department_id,
        classroom_id: this.classroom_id,
        subject_id: this.subject_id,
        page: page,
        page_size: this.page_size,
      };
    }
    if (
      this.storageService.getRole() == 2 ||
      this.storageService.getRole() == 3
    ) {
      this.showpage = true;
    }
    let liveclasslist = await this.globalService.get(
      "classVideoDetail/get/liveclass",
      filter
    );
    this.liveclasslist = liveclasslist["content"]["rows"];
    this.total = liveclasslist["content"]["count"];
    if (this.total > 0) {
      this.table_pagination = true;
    }

    this.spinner.hide();
  }

  openScrollableContent(longContent) {
    if (this.ls.get("token")) {
      this.modalService.open(longContent, { scrollable: true });
    }
  }

  async onDepartmentChange() {
    await this.getSubjectDropdown();
    await this.getProfessorDropdown();
  }

  async getProfessorDropdown() {
    this.spinner.show();

    const filter: any = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      role_id: this.storageService.getRole(),
    };

    const departmentId = this.searchForm.get("depname")?.value;

    if (departmentId) {
      filter.department_id = departmentId;
    }

    const professor = await this.globalService.get(
      "user/profeser/dropdown",
      filter,
      true
    );

    this.professorData = professor["content"] || [];

    // Clear selected professor after department changes
    this.searchForm.patchValue({
      proname: null,
    });
    this.professor_id = null;

    this.spinner.hide();
  }

  async getSubjectDropdown() {
    const filter: any = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      role_id: this.storageService.getRole(),
    };

    const departmentId = this.searchForm.get("depname")?.value;
    if (departmentId) {
      filter.department_id = departmentId;
    }

    const subject = await this.globalService.get(
      "subject/list/dropdown",
      filter,
      true
    );

    this.subjectData = subject["content"] || [];

    // Clear previously selected subject if needed
    this.searchForm.patchValue({
      subname: null,
    });
  }

  getUtcToLocale(dateValue, timeValue, isDateRequested) {
    return this.globalService.getUtcToLocale(dateValue, timeValue, isDateRequested);
  }

  openLiveClass(video_id) {
    if (this.storageService.getRole() == 5) {
      if (this.route.queryParams["value"].loginType == "impersonate") {
        window.open("/streaming/class/" + video_id + "&loginType=impersonate");
      } else {
        window.open("/streaming/class/" + video_id, "_blank");
      }
    } else {
      if (this.route.queryParams["value"].loginType == "impersonate") {
        window.open("/stream/myclass/" + video_id + "&loginType=impersonate");
      } else window.open("/stream/myclass/" + video_id, "_blank");
    }
  }

  res() {
    this.filtervalues = false;
    this.filter_date = null;
    this.department_id = null;
    this.subject_id = null;
    this.professor_id = this.professorid;
    this.classroom_id = null;
    this.filter_from = null;
    this.filter_end = null;
    this.searchForm.reset();
    this.getLiveStreamClass(this.page);
  }
  paginationCount(value) {
    this.page = 1;
    if (value >= 5) {
      this.page_size = value;
    }
    this.getLiveStreamClass(this.page);
  }
}

